// Patient-visible summaries shown when selecting an Easy Read Journey.
// Keep this data isolated from the runtime Journey generator so the national
// clinical source inventory can review it without importing browser-only code.
export const EASY_READ_JOURNEY_SUMMARIES = Object.freeze({
  'easy-read-day-surgery': 'A shorter, picture-supported guide to coming to hospital for day surgery.',
  'easy-read-outpatient-appointment': 'A shorter, picture-supported guide to coming to hospital for an outpatient appointment.',
  'easy-read-scan': 'A shorter, picture-supported guide to having a scan in hospital.',
  'easy-read-blood-test': 'A shorter, picture-supported guide to having a blood test.',
  'easy-read-emergency-department': 'A shorter, picture-supported guide to what may happen in the Emergency Department.',
  'easy-read-hospital-stay': 'A shorter, picture-supported guide to staying on a hospital ward.',
});
